import { z } from "zod";

import { productResponseSchema } from "./products.schema";

export const checkoutResponseSchema = z
  .object({
    data: z.object({
      product: productResponseSchema,
      redirect_url: z.url(),
    }),
  })
  .transform(({ data }) => ({
    product: data.product,
    redirectUrl: data.redirect_url,
  }));
